var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "course-package" },
    [
      _vm._l(_vm.config, function(item, index) {
        return _c(
          "div",
          {
            key: index,
            staticClass: "item",
            on: {
              click: function($event) {
                return _vm.goList(item.key)
              }
            }
          },
          [
            _c("p", { staticClass: "item-img" }, [
              _c("img", {
                staticClass: "class",
                attrs: { src: item.icon, alt: "" }
              })
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "item-content" }, [
              _vm._v(_vm._s(item.value))
            ])
          ]
        )
      }),
      _vm._v(" "),
      _vm.official
        ? _c("div", { staticClass: "official_account" }, [
            _c("div", { staticClass: "official_account_content" }, [
              _c("div", { staticClass: "official_account_box" }, [
                _c("img", {
                  staticClass: "wechat_pic",
                  attrs: {
                    src: require("../../../static/images/official_bg.png"),
                    alt: ""
                  }
                }),
                _vm._v(" "),
                _vm._m(0),
                _vm._v(" "),
                _c("input", {
                  staticClass: "offcn_help",
                  attrs: { type: "text", value: "中公教育学习助手" }
                }),
                _vm._v(" "),
                _c("span", { on: { click: _vm.close_mask } }, [
                  _vm._v("复制公众号去关注")
                ])
              ]),
              _vm._v(" "),
              _c("img", {
                staticClass: "close_btn",
                attrs: {
                  src: require("../../../static/images/close.png"),
                  alt: ""
                },
                on: { click: _vm.close_mask }
              })
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.applets_flag && _vm.ios
        ? _c("popup", {
            staticClass: "popop_content",
            attrs: { type: 1 },
            on: { isopen: _vm.popup }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.applets_flag && _vm.android
        ? _c("popup", {
            staticClass: "popop_content",
            attrs: { type: 2 },
            on: { isopen: _vm.popup }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.zujian_flag
        ? _c("div", { staticClass: "class_dialog" }, [
            _c("div", { staticClass: "dialog_box" }, [
              _c("div", { staticClass: "dialog_message" }, [
                _vm._v("手机浏览器暂不支持查看该课件"),
                _c("br"),
                _vm._v('你可在"' + _vm._s(_vm.appname) + '"进行查看')
              ]),
              _vm._v(" "),
              _c("p", [
                _c("span", { on: { click: _vm.cancel_flag } }, [
                  _vm._v("取消")
                ]),
                _vm._v(" "),
                _vm.android
                  ? _c("span", { staticClass: "goapp" }, [
                      _c(
                        "a",
                        {
                          attrs: { href: _vm.scheme },
                          on: { click: _vm.search_flag }
                        },
                        [_vm._v("打开APP")]
                      )
                    ])
                  : _vm.ios
                  ? _c(
                      "span",
                      { staticClass: "goapp", on: { click: _vm.search_flag } },
                      [_vm._v("去APP查看")]
                    )
                  : _vm._e()
              ])
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.arshow ? _c("arouse", { on: { arouse: _vm.receive } }) : _vm._e()
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("关注微信公众号"),
      _c("b", [_vm._v("“中公教育学习助手”")]),
      _c("br"),
      _vm._v("绑定开课手机号，以获取更多服务")
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-185548bb", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-185548bb","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/coursePackages/index.vue
// module id = null
// module chunks = 